import { Stack, useTheme } from "@mui/material";
import Slider from "react-slick";

import { imageSource, Strings } from "@app/constants";
import { useResponsive } from "@app/hooks";
import { HeroBanner } from "./hero-banner";

const HeroSection = ({
  activeFilter,
  setActiveFilter,
  nonParentCategoriesData,
}: any) => {
  const isMobile = useResponsive("down", "md");
  const theme = useTheme();
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 3000,
    variableWidth: false,
    adaptiveHeight: true, 
  };
  const imagesData = [imageSource.homeBannerImage, imageSource.car];
  return (
    <Stack sx={{ width: "100%" }}>
      <Stack
        sx={{
          width: "100%",
          position: "relative",
          overflow: "visible",
          "& .slick-slider": {
            overflow: "visible",
          },
          "& .slick-track": {
            display: "flex",
            alignItems: "stretch",
          },
          "& .slick-slide": {
            height: "auto",
            "& > div": {
              height: "100%",
            },
          },
          "& .slick-dots": {
            bottom: "20px",
            "& li button:before": {
              color: theme.palette.common.white,
              fontSize: "12px",
            },
            "& li.slick-active button:before": {
              color: theme.palette.primary.main,
              opacity: 1,
            },
          },
        }}
      >
        <Slider {...settings}>
          {imagesData?.map((image) => (
            <Stack
              sx={{
                backgroundImage: `url(${image})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
                width: "100%",
                height: "90vh",
                minHeight: 550,
                maxHeight: 600,
              }}
            ></Stack>
          ))}
        </Slider>
        <HeroBanner />
      </Stack>

      {/* <Typography
        variant="h3"
        fontWeight="700"
        textAlign="center"
        fontFamily={"Work Sans"}
        sx={{ fontSize: { xs: 28, md: 36 } }}
      >
        {Strings.home.selectAVehicle}
      </Typography> */}

      {/* <VehicleFilters
        activeFilter={activeFilter}
        setActiveFilter={setActiveFilter}
        nonParentCategoriesData={nonParentCategoriesData}
      />
      <Spacing top={5} /> */}
    </Stack>
  );
};

export { HeroSection };
